import { featureItems } from '@/mocks/home';

export default function Features() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <p className="text-xs font-medium text-secondary-500 uppercase tracking-widest font-label mb-3">
          为什么选择我们
        </p>
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight mb-12 md:mb-16">
          全网最全
          <br />
          吃瓜第一线
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {featureItems.map((feature) => (
            <div
              key={feature.title}
              className="bg-background-100 rounded-xl p-6 md:p-8 hover:bg-background-200/60 transition-colors duration-300"
            >
              <div className="w-10 h-10 flex items-center justify-center mb-5">
                <i className={`${feature.icon} text-2xl text-foreground-950`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-3 font-heading">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}